import {
  CREATE_SESSION_REQUEST,
  CREATE_SESSION_SUCCESS,
  CREATE_SESSION_FAILURE,
  GET_SESSIONS_REQUEST,
  GET_SESSIONS_SUCCESS,
  GET_SESSIONS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  session: null,      // for create
  sessions: [],       // for list
  pagination: {},     // for pagination
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ================= CREATE ================= */
    case CREATE_SESSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        session: action.payload,
      };

    case CREATE_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /* ================= GET LIST ================= */
    case GET_SESSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_SESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        sessions: action.payload?.sessions || [],
        pagination: action.payload?.pagination || {},
      };

    case GET_SESSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default sessionReducer;